import {
  listSourceGDAs_DDAs,
  listSourceVariantAll_VDAs,
  listSourceAcademic,
  listSourceDiseaseAll,
  listSourceGeneALL,
} from './tableHelpers';

const variantSourceButtons = ['VARIANTS', 'VDA'];
const diseasesSourceButtons = ['DISEASES', 'CHEMICALS'];
const genesSourceButtons = ['GENES'];
const gdaDDASourceButtons = ['GDA', 'DDA'];

const allowedSourcesByTab = {
  CHEMICALS: ['CLINICALTRIALS', 'ALL', 'TEXTMINING_HUMAN', 'TEXTMINING_MODELS'],
};

export function isSourceEnabledForTab(source, tab) {
  if (allowedSourcesByTab[tab]) {
    return allowedSourcesByTab[tab].includes(source);
  }

  const tabsWithClingen = ['GDA', 'VDA', 'DISEASES', 'GENES', 'VARIANTS'];
  const tabsWithGencc = ['VDA', 'DISEASES', 'GENES', 'VARIANTS', 'GDA'];

  if (source === 'CLINGEN' && !tabsWithClingen.includes(tab)) {
    return false;
  }
  if (source === 'GENCC' && !tabsWithGencc.includes(tab)) {
    return false;
  }

  return true;
}

function cleanCuratedSources(sources, tab) {
  return sources;
}

export function getSourceList({ tab, restrictSources }) {
  if (restrictSources === 'CURATED') return listSourceAcademic;

  if (variantSourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceVariantAll_VDAs };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  if (diseasesSourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceDiseaseAll };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  if (genesSourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceGeneALL };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  if (gdaDDASourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceGDAs_DDAs };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  return [];
}
